import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

// CSS
import * as styles from "./Footer.module.css";

const FooterComponent = props => {
  return (
    <>
      <div className={`container-fluid ${styles.diabetesLp__footer__cont}`}>
        <div className={`row ${styles.diabetesLp__footer__row}`}>
          <div className={`col-12`}>
            {/* LOGO IMAGE */}
            <div className="text-center">
              <StaticImage
                src="../../../../images/LandingPage/twin-logo-icn.png"
                alt="banner_image"
                className="img-fluid"
                placeholder="blurred"
                quality={90}
              />
            </div>
          </div>
          <div className={`col-12`}>
            <div className={`${styles.diabetesLp__footer__bottom}`}>
              <div className={styles.diabetesLp__footer__bottomLink}>
                <Link to={props.termsRedirectionUrl}>
                  <span role="presentation">Privacy Policy</span>
                </Link>
                <Link to={props.termsRedirectionUrl}>
                  <span role="presentation">Terms of Use</span>
                </Link>
              </div>
              <div className={`${styles.diabetesLp__footer__para}`}>
                <p>©Twin Health India, 2025. All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FooterComponent;
